import { LotesFaturamentoRoutingModule } from './lotes-faturamento-routing.module';
import { CoreModule } from 'src/app/core/core.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LotesFaturamentoComponent } from './lotes-faturamento.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [LotesFaturamentoComponent],
  imports: [
    CommonModule,
    LotesFaturamentoRoutingModule,
    SharedModule,
    CoreModule,
    ReactiveFormsModule
  ]
})
export class LotesFaturamentoModule {}
